<template>
  <div class="has-background-white is-border is-margin-top">
    <tabs
      :niveau="2"
      :links="tabList"
      :current-tab="tab"
      @changeView="tab = $event"
      mode="emitter"
      :level="2"
      class="has-background-light is-border-bottom"></tabs>
    <contacts-light-list
      v-if="tab == 'CONTACTS'"
      :contacts="programContacts"
      :loading="contactLoading"
      :total-page="contactTotalPage"
      :total-contact="totalContact"
      :current-page="contactCurrentPage"
      @loadItems="getContactsProgram"></contacts-light-list>
    <claim-light-list
      v-else-if="tab == 'CLAIMS'"
      :claims="programClaims"
      :loading="claimLoading"
      :total-page="claimTotalPage"
      :total-claim="totalClaim"
      :current-page="claimCurrentPage"
      @loadItems="getProgramClaim"></claim-light-list>
  </div>
</template>

<script>

export default {
  name: 'ProgramPromoteurContacts',
  components: {
    ContactsLightList: () => import('@/components/contacts/ContactsLightList'),
    ClaimLightList: () => import('@/components/denunciation/ClaimLightList')
  },
  data () {
    return {
      tab: 'CONTACTS',
      sortBy: {},
      filters: {},
      contactListTab: 'Contact',
      contactLoading: true,
      contactTotalPage: 0,
      contactCurrentPage: 1,
      claimLoading: true,
      claimTotalPage: 0,
      claimCurrentPage: 1,
      programContacts: null,
      totalContact: null,
      totalClaim: null,
      loading: true
    }
  },
  computed: {
    tabList () {
      return [
        { label: `Contacts (${this.totalContact})`, link: 'CONTACTS' },
        { label: `Dénonciations (${this.totalClaim})`, link: 'CLAIMS' }
      ]
    }
  },
  created () {
    this.getContactsProgram(this.contactCurrentPage)
    this.getProgramClaim(this.claimCurrentPage)
  },
  methods: {
    async getProgramClaim (page = null) {
      this.claimLoading = true
      let params = {
        sort: 'created_on:desc',
        status: ['pending', 'approved'],
        program: this.$route.params.id,
        per_page: 50,
        page: page
      }
      try {
        let { data } = await this.$api.get(this.$resources.CLAIM, params)
        this.claimLoading = false
        this.programClaims = data.items
        this.claimTotalPage = data.pages
        this.claimCurrentPage = data.page
        this.totalClaim = data.count
      } catch (e) {
        this.claimLoading = false
      }
    },
    async getContactsProgram (page = null) {
      this.contactLoading = true
      let params = {
        per_page: 50,
        page: page
      }
      try {
        let { data } = await this.$api.get(`/programs/${this.$route.params.id}/contacts`, params)
        this.contactLoading = false
        this.programContacts = data.items
        this.contactTotalPage = data.pages
        this.contactCurrentPage = data.page
        this.totalContact = data.count
      } catch (e) {
        this.contactLoading = false
      }
    }
  }
}
</script>
